<template>
  <Dropdown ref="dropdown">
    <template #button="{ open }">
      <button
        type="button"
        class="p-2 rounded-full bg-transparent hover:bg-gray-200 focus:outline-none"
        :disabled="loading"
        @click="open"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="12" cy="12" r="1" />
          <circle cx="12" cy="19" r="1" />
          <circle cx="12" cy="5" r="1" />
        </svg>
      </button>
    </template>
    <div
      class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      <div class="py-1">
        <button
          type="button"
          class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-red-700 hover:bg-red-100 hover:text-red-900"
          role="menuitem"
          @click="confirmRemove"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="mr-3 h-5 w-5 text-red-400 group-hover:text-red-500"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <line x1="4" y1="7" x2="20" y2="7" />
            <line x1="10" y1="11" x2="10" y2="17" />
            <line x1="14" y1="11" x2="14" y2="17" />
            <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
            <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
          </svg>
          {{ $t('global.delete') }}
        </button>
      </div>
    </div>
  </Dropdown>
</template>

<script>
import { contactNotesClient } from '@/api/clients';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
    noteId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeMenu() {
      this.$refs.dropdown.toggleMenu();
    },
    confirmRemove() {
      this.closeMenu();

      this.$modal.show({
        component: () => import('Components/BaseDialogDelete.vue'),
        on: {
          confirmed: () => {
            this.remove();
          },
        },
        hideEvent: 'closed',
      });
    },
    async remove() {
      try {
        this.loading = true;

        await contactNotesClient.destroy(this.contactId, this.noteId);

        this.$emit('destroy');
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
